import { combineReducers } from "redux";
import fund_request from "../features/admin/fund_request/Slice";

const fundRequest = combineReducers({
  fund_request: fund_request,
});

export default fundRequest;
